import React from "react";
import LoginForm from "./LoginForm";
import PropTypes from "prop-types";
import { useMutation, useQueryClient } from "react-query";
import { submitLoginForm } from "../../../queries/session";
import { createErrors } from "../../../queries/helpers";
import { useErrorHandler } from "react-error-boundary";

const LoginPage = ({ history }) => {
  const handleError = useErrorHandler();
  const queryClient = useQueryClient();
  const login = useMutation(async (formData) => {
    return await submitLoginForm(formData).then((jwt) => {
      return jwt;
    });
  });

  const onSubmit = async (values) => {
    // values.type = "SuperAdmin";
    return await login
      .mutateAsync(values)
      .then((jwt) => {
        queryClient.setQueryData("jwt", jwt);
        history.push("/");
      })
      .catch((error) => {
        return createErrors(
          error,
          "Login failed - invalid credentials",
          handleError
        );
      });
  };

  return (
    <div className="fs-wrap fs-form">
      <LoginForm onSubmit={onSubmit} />
    </div>
  );
};

LoginPage.propTypes = {
  history: PropTypes.object,
};

export default LoginPage;
